import { importLibrary } from '@googlemaps/js-api-loader';
import type { LabeledOption } from '@iheartjane/types';

const LOCATION_SEARCH_COUNTRIES = ['us', 'pr', 'ca'];

interface GetPlacePredictionsParams {
  countries?: string[];
  input: string;
  /** Initializer stub that replaces the v1 JS api loader. This should be a function that sets the Google API options. */
  loader: () => void;
}

const getPlacePredictions = async ({
  countries,
  input,
  loader,
}: GetPlacePredictionsParams) => {
  loader();

  const { AutocompleteSessionToken, AutocompleteSuggestion } =
    await importLibrary('places');
  const sessionToken = new AutocompleteSessionToken();

  const response = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
    includedRegionCodes: countries,
    input,
    sessionToken,
  });

  return response.suggestions;
};

interface GetAddressesParams {
  countries?: string[];
  input: string;
  /** Initializer stub that replaces the v1 JS api loader. This should be a function that sets the Google API options. */
  loader: () => void;
}

export const getAddresses = async ({
  loader,
  input,
  countries = LOCATION_SEARCH_COUNTRIES,
}: GetAddressesParams): Promise<LabeledOption[]> => {
  const suggestions = await getPlacePredictions({ countries, input, loader });
  const addresses = suggestions.map(({ placePrediction }) => {
    if (!placePrediction) {
      return { label: '', value: '' };
    }

    const description = placePrediction.text.text;

    const values = description.split(', ');
    const value =
      values.length === 1 ? values[0] : values.slice(0, -1).join(', ');

    return {
      label: value,
      value,
    };
  });

  return addresses.filter((addr) => addr.value !== '');
};
